import {
  addActionInSubsetReducer,
  deleteActionInSubsetReducer,
  updateActionInSubsetReducer,
} from '../../helpers/recipesReducerHelpers';
import {SlaEditorActionTypesEnum, SlaEditorSpecificAction} from './slaEditorActions';
import {SlaEditorSpecificState} from './slaEditorState';

/*
 * Reducer.
 */

export function slaEditorSpecificReducer(state: SlaEditorSpecificState, action: SlaEditorSpecificAction) {
  switch (action.type) {
    case SlaEditorActionTypesEnum.SET_BREACH_UNREPLIED:
      return {
        ...state,
        unreplied: {
          ...state.unreplied,
          breach: action.payload,
        },
      };

    case SlaEditorActionTypesEnum.SET_WARNING_UNREPLIED:
      return {
        ...state,
        unreplied: {
          ...state.unreplied,
          warning: action.payload,
        },
      };

    case SlaEditorActionTypesEnum.ADD_ACTION:
      return addActionInSubsetReducer(state, action.payload.action, action.payload.subset);

    case SlaEditorActionTypesEnum.UPDATE_ACTION:
      return updateActionInSubsetReducer(
        state,
        action.payload.predicate,
        action.payload.update,
        action.payload.subset,
      );

    case SlaEditorActionTypesEnum.DELETE_ACTION:
      return deleteActionInSubsetReducer(state, action.payload.predicate, action.payload.subset);

    case SlaEditorActionTypesEnum.SET_TAG:
      return {
        ...state,
        tags: {
          ...state.tags,
          [action.payload.subset]: action.payload.tagId,
        },
      };

    default:
      return state;
  }
}
